import React, { useState } from 'react';
import { Button } from '../../../components/Button';
import { Modal } from '../../../components/Modal';
import { cn } from '../../../utils/cn';
import type { UserProfile } from '../../../types';

interface TransferOwnershipModalProps {
    isOpen: boolean;
    onClose: () => void;
    members: UserProfile[];
    currentUserId: string | undefined;
    onConfirm: (newOwnerId: string) => void;
}

export const TransferOwnershipModal: React.FC<TransferOwnershipModalProps> = ({
    isOpen,
    onClose,
    members,
    currentUserId,
    onConfirm
}) => {
    const [selectedId, setSelectedId] = useState<string>('');

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Transfer Ownership"
        >
            <div className="space-y-4">
                <p className="text-sm text-text-muted">
                    Select a new owner for this tab. You will become a regular member.
                </p>
                <div className="space-y-2 max-h-[300px] overflow-y-auto">
                    {members
                        .filter(p => p.uid !== currentUserId)
                        .map(profile => (
                            <button
                                key={profile.uid}
                                onClick={() => { setSelectedId(profile.uid); }}
                                className={cn(
                                    "w-full flex items-center gap-3 p-3 rounded-xl border transition-all text-left",
                                    selectedId === profile.uid
                                        ? "border-primary-500 bg-primary-50 ring-1 ring-primary-500"
                                        : "border-border-default hover:bg-bg-card-alt"
                                )}
                            >
                                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-bg-card-alt text-text-muted font-bold text-xs">
                                    {profile.displayName.slice(0, 2).toUpperCase()}
                                </div>
                                <span className="font-medium text-text-heading">{profile.displayName}</span>
                            </button>
                        ))}

                    {members.filter(p => p.uid !== currentUserId).length === 0 && (
                        <p className="text-center text-text-muted italic py-4">No other members to transfer to.</p>
                    )}
                </div>

                <Button
                    disabled={!selectedId}
                    className="w-full h-12 mt-4"
                    onClick={() => { onConfirm(selectedId); }}
                >
                    Review Transfer
                </Button>
            </div>
        </Modal>
    );
};
